import { ReactNode } from 'react';
import styles from './DisabledGuarantorDetail.module.css';

type TProps = { label: string; value: ReactNode | null };

export const DisabledGuarantorDetail = ({ label, value }: TProps) => {
  if (!value) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.label}>{label}</div>
      <div>{value}</div>
    </div>
  );
};
